export default __webpack_public_path__ + "mstile-150x150.png";